<script lang="ts">
  import Icon from "./Icon.svelte";

  export let summary: string;
</script>

<details class="Details">
  <summary class="Details-summary">
    {summary}
    <span class="Details-icon">
      <Icon type="chevron-down" />
    </span>
  </summary>
  <div class="Details-content">
    <slot />
  </div>
</details>

<style>
  .Details-summary {
    align-items: center;
    background: var(--color-blue);
    color: var(--color-white);
    display: flex;
    font-family: var(--font-family-decoration);
    font-size: var(--size-22);
    font-weight: 700;
    justify-content: space-between;
    list-style: none;
    padding-block: var(--size-20);
    padding-inline: var(--app-inline-space);
  }

  .Details-summary::-webkit-details-marker {
    display: none;
  }

  .Details[open] .Details-icon {
    rotate: 0.5turn;
  }

  .Details-content {
    padding-block: var(--size-32);
    padding-inline: var(--app-inline-space);
  }
</style>
